import { Box, FormControl, FormLabel, HStack, Tag, Text, Textarea, VStack } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { testIds } from './testIds';
import type { PlacementUnit } from './types';

export function UnitsAndNotes({
  units,
  notes,
  onNotesChange,
}: {
  units: PlacementUnit[];
  notes: string;
  onNotesChange: (notes: string) => void;
}): React.ReactElement {
  return (
    <VStack align="stretch" gap={4} w="full">
      <Box>
        <Text fontWeight="semibold" mb={1}>
          <Trans>Units of competency</Trans>
        </Text>
        <Text fontSize="sm" color="fg.muted" mb={2}>
          <Trans>
            All units with outstanding work placement requirements are included automatically.
          </Trans>
        </Text>
        <VStack
          align="stretch"
          gap={2}
          borderWidth="1px"
          borderColor="border.default"
          borderRadius="md"
          p={3}
        >
          {units.map((unit) => (
            <HStack key={unit.unitOfCompetencyId} gap={3}>
              <Tag size="sm" colorScheme="gray" flexShrink={0}>
                {unit.code}
              </Tag>
              <Text fontSize="sm">{unit.title}</Text>
            </HStack>
          ))}
        </VStack>
      </Box>

      <FormControl>
        <FormLabel>
          <Trans>Notes</Trans>
        </FormLabel>
        <Textarea
          data-testid={testIds.notesInput}
          placeholder={t`Optional notes about this placement`}
          rows={3}
          value={notes}
          onChange={(event) => onNotesChange(event.target.value)}
        />
      </FormControl>
    </VStack>
  );
}
